const ACTIONS = {
  ADD: "Add",
  DELETE: "Delete",
  EDIT: "Edit",
  GET: "Get",
};

export { ACTIONS };
